import request from "@/api/request";

export function search(data) {
    return request({
        url: '/api/salary/search',
        method: 'post',
        data: data
    })
}


export function info(query) {
    return request({
        url: '/api/salary/info',
        method: 'get',
        params: query
    })
}

//新一线城市
export function newCity() {
    return request({
        url: '/api/salary/newCitys',
        method: 'get'
    })
}

//职位
export function positionConfigList() {
    return request({
        url: '/api/salary/position',
        method: 'get'
    })
}

//热门职位
export function hotPosition() {
    return request({
        url: '/api/salary/hotPosition',
        method: 'get'
    })
}

//https://m.zhipin.com/wapi/zpboss/h5/marketpay/statistics.json?positionId=100101&cityId=0&experienceCode=103
export function statistics(data) {
    return request({
        url: '/api/salary/statistics',
        method: 'post',
        data: data
    })
}


